import type { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { Effect, Timing } from "./effect";

export const STANDARD_MOVEMENT_TIME = 300;

export class MovementEffect extends Effect {
	static key = "MovementEffect";
	readonly thing: PhysicalThing;
	readonly origin: XY;
	readonly destination: XY;
	readonly time: number;

	constructor(thing: PhysicalThing, origin: XY, destination: XY, time: number = STANDARD_MOVEMENT_TIME) {
		super();
		if (origin.equals(destination)) {
			throw new Error("MovementEffect: origin and destination must be different");
		}
		this.thing = thing;
		this.origin = origin;
		this.destination = destination;
		this.time = time;
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
